interface Item {
  id: number | string;
  name: string;
  selectValue?: {
    type: 'static' | 'inputParam';
    value: any;
  };
  isSensitive?: boolean;
}

// export const transformParamsArrayToObject = (arr: {
//   id: number | string;
//   name: string;
//   selectValue?: {
//     type: 'static' | 'inputParam';
//     value: any;
//   };
//   isSensitive?: boolean;
// }[]) => (arr.reduce(
//   (accumulator, curr) => {
//     const getValue = (currItem: Item) => {
//       if (currItem.selectValue) {
//         if (currItem.selectValue?.type === 'inputParam') {
//           return `{{${currItem.selectValue?.value}}}`;
//         }
//         if (
//           Object.hasOwn(currItem.selectValue, 'value')
//         && currItem.selectValue?.value?.data === ''
//         ) {
//           return '';
//         }
//         return currItem.selectValue?.value?.data || currItem.selectValue?.value;
//       }
//       return '';
//     };

//     return { ...accumulator, [curr.name]: getValue(curr) };
//   },
//   {},
// ));

export const transformParamsFromApi = (arr: {
  id: number | string;
  name: string;
  value: any;
  isSensitive?: boolean;
}[]) => {
  if (arr === null || !Array.isArray(arr)) {
    return [];
  }

  return arr.map((element, index) => ({
    id: index,
    name: element.name,
    selectValue: {
      type: 'static',
      value: element.value,
    },
    isSensitive: element.isSensitive || false,
  }));
};

export const transformParamsArrayToList = (arr: {
  id: number | string;
  name: string;
  selectValue?: {
    type: 'static' | 'inputParam';
    value: any;
  };
  isSensitive?: boolean;
}[]) => {
  const getValue = (currItem: Item) => {
    if (currItem.selectValue) {
      if (currItem.selectValue?.type === 'inputParam') {
        return `{{${currItem.selectValue?.value}}}`;
      }
      if (
        Object.hasOwn(currItem.selectValue, 'value')
      && currItem.selectValue?.value?.data === ''
      ) {
        return '';
      }
      return currItem.selectValue?.value?.data || currItem.selectValue?.value;
    }
    return '';
  };

  return arr.map((item) => ({
    id: item.id,
    name: item.name,
    value: getValue(item),
    isSensitive: item.isSensitive || false,
  }));
};

export const transformOAuthDiscoverDataToConfig = (obj: Record<any, any>) => {
  if (!obj || Object.keys(obj).length === 0) return null;

  const {
    client_registration: clientRegistration,
    data: discoveredMetaData, server_defined: serverDefined,
  } = obj;

  return {
    client_id: clientRegistration?.client_id ?? '',
    client_secret: clientRegistration?.client_secret ?? '',
    authorization_server_url: discoveredMetaData?.authorization_endpoint ?? '',
    scopes: discoveredMetaData?.scopes_supported?.join(' ') ?? serverDefined?.scope ?? '',
    access_token_url: discoveredMetaData?.token_endpoint ?? '',
    grant_type: 'authorization_code',
  };
};

export const oauthFieldsConfig : any[] = [
  {
    name: 'grant_type',
    label: 'Grant Type',
    componentType: 'select',
    testId: 'api-authentication-oauth-granttype',
    options: [
      {
        label: 'auth_type_oauth_grant_type_authorization_code',
        value: 'authorization_code',
        testId: 'granttype-auth-code',
      },
    ],
  },
  {
    name: 'client_id',
    label: 'Client ID',
    type: 'text',
    autoComplete: 'one-time-code',
    testId: 'api-authentication-oauth-clientid',
    required: true,
  },
  {
    name: 'client_secret',
    label: 'Client Secret',
    type: 'password',
    autoComplete: 'one-time-code',
    testId: 'api-authentication-oauth-client-secret',
    showTogglePassword: true,
    required: true,
  },
  {
    name: 'authorization_server_url',
    label: 'Authorization Server URL',
    type: 'url',
    autoComplete: 'one-time-code',
    testId: 'api-authentication-oauth-authorization-server-url',
    required: true,
  },
  {
    name: 'scopes',
    label: 'Scopes',
    type: 'text',
    autoComplete: 'one-time-code',
    testId: 'api-authentication-oauth-scopes',
    required: false,
    helpText: 'Space delimited scopes',
  },
  {
    name: 'authorization_server_request_params',
    componentType: 'keyValueInput',
    addBtnLabel: 'auth_oauth_authorization_params_addbtn_label',
    title: 'auth_oauth_authorization_params_title',
    testId: 'authentication-oauth-authorization-server-request-params',
  },
  {
    name: 'access_token_url',
    label: 'Access token URL',
    type: 'url',
    autoComplete: 'one-time-code',
    testId: 'api-authentication-oauth-access-token-url',
    required: true,
  },
  {
    name: 'access_token_request_params',
    componentType: 'keyValueInput',
    addBtnLabel: 'auth_oauth_access_token_params_addbtn_label',
    title: 'auth_oauth_access_token_params_title',
    testId: 'authentication-oauth-access-token-request-params',
  },
];

export function getStateFromUrl(authUrl: string) {
  try {
    const url = new URL(authUrl);
    return url.searchParams.get('state');
  } catch {
    return null;
  }
}
